<template>
	<div class="plan-wrapper">
		<div class="header">
			<div class="header-title">
				<span class="back" @click="fallback">
					<i class="iconfont">&#xe613;</i>
				</span>
				{{currentDate}}份计划
			</div>
		    <div class="header-select">
		    	<awesome-picker
			      	ref="selectDatePicker"
			      	:data="picker.data"
			      	:textTitle="picker.textTitle" 	
			      	:anchor="picker.anchor"
			      	@confirm="handleSelectDate"
			    >
			    </awesome-picker>
			    <div class="select-wrapper" @click="DateSelectShow">
			    	<span class="select">
			    		{{currentDate}}
			    	</span>
			    	<span class="icon-wrapper">
			    		<i class="iconfont select-icon">&#xe61c;</i>
			    	</span>
		    	</div>
	        </div>
		</div>
		<div class="content-wrapper" ref="planScroll">
			<div>
				<div class="content-box" ref="activeScroll" >
					<ul class="content-tab" >
						<li class="tab-item" :class="{active: currentTabIndex == 1}" @click="handleTba(1)">合计</li>
						<li class="tab-item" :class="{active: currentTabIndex == 2}" @click="handleTba(2)">竞价</li>
						<li class="tab-item" :class="{active: currentTabIndex == 3}" @click="handleTba(3)">优化</li>
						<li class="tab-item" :class="{active: currentTabIndex == 4}" @click="handleTba(4)">门户</li>
						<li class="tab-item" :class="{active: currentTabIndex == 6}" @click="handleTba(6)">新媒体</li>
						<li class="tab-item" :class="{active: currentTabIndex == 7}" @click="handleTba(7)">资源合作</li>
						<li class="tab-item" :class="{active: currentTabIndex == 8}" @click="handleTba(8)">无轨迹</li>
						<li class="tab-item" :class="{active: currentTabIndex == 5}" @click="handleTba(5)">其他</li>
					</ul>
				</div>
				<ul class="tab-detail">
					<li class="detail-item">
						<div class="item-title">
							<i class="iconfont number-icon">&#xe7d3;</i>
							<p class="text">到诊</p>
						</div>
						<p class="number-wrap">计划: <span class="number">{{total_in_count}}</span> 人</p>
						<p class="number-wrap">实际: <span class="number">{{current_in_count}}</span> 人</p>
					</li>
					<li class="detail-item">
						<div class="item-title">
							<i class="iconfont number-icon">&#xe785;</i>
							<p class="text">到诊成本</p>
						</div>
						<p class="number-wrap">计划: <span class="number">{{total_in_base}}</span> 元/人</p>
						<p class="number-wrap">实际:<span class="number">{{current_in_base}}</span> 元/人</p>
					</li>
					<li class="detail-item">
						<div class="item-title">
							<i class="iconfont number-icon">&#xe78a;</i>
							<p class="text">对话</p>
						</div>
						<p class="number-wrap">计划: <span class="number">{{total_dialog_count	}}</span> 条</p>
						<p class="number-wrap">实际: <span class="number">{{current_dialog_count}}</span> 条</p>
					</li>
					<li to="/create-plan" tag="li" class="detail-item">
						<div class="item-title">
							<i class="iconfont number-icon">&#xe785;</i>
							<p class="text">对话成本</p>
						</div>
						<p class="number-wrap">计划: <span class="number">{{total_dialog_base}}</span> 元/条</p>
						<p class="number-wrap">实际: <span class="number">{{current_dialog_base}}</span> 元/人</p>
					</li>
					<li class="detail-item">
						<div class="item-title">
							<i class="iconfont number-icon">&#xe78a;</i>
							<p class="text">确诊对话</p>
						</div>
						<p class="number-wrap">计划: <span class="number">{{total_sure_count	}}</span> 条</p>
						<p class="number-wrap">实际: <span class="number">{{current_sure_count}}</span> 条</p>
					</li>
					<li to="/create-plan" tag="li" class="detail-item">
						<div class="item-title">
							<i class="iconfont number-icon">&#xe785;</i>
							<p class="text">确诊对话成本</p>
						</div>
						<p class="number-wrap">计划: <span class="number">{{total_sure_base}}</span> 元/条</p>
						<p class="number-wrap">实际: <span class="number">{{current_sure_base}}</span> 元/人</p>
					</li>
				</ul>
				<div class="total-wrapper">
					<p class="total-item">
						<span class="title"><i class="iconfont">&#xe69d;</i>消费</span>
						<span class="content col">本月到诊冲刺目标:<b>{{come_on}}</b>人</span>
					</p>
					<p class="total-item">
						<span class="title">预算:<b>{{total_order_price}}</b>万元</span>
						<span class="content">实际:<b>{{current_cost_price}}</b>万元</span>
					</p>
                    <div class="update" @click="recordUpdate()">
                        <span class="text">{{limitDate}}</span>
                        <span class="btn" ><i class="iconfont">&#xe791;</i> 编辑月计划</span>
                    </div>
				</div>
			</div>
			<div @click="handleCreatePlan" class="create-btn" v-show="isCreate">
				创建月任务
			</div>
		</div>
		<!-- <div class="link-grounp">
			<router-link class="link-btn" to="/register" tag="div">录入数据</router-link>
			<router-link class="link-btn" :to="{name: 'DReport', params: {date: currentDate}}" tag="div">
				日数据报表
				<span class="tips" v-show="isTips">{{tips}}</span>
			</router-link>
		</div> -->
		<v-footer></v-footer>
	</div>	
</template>

<script>
	import axios from 'axios'
	import BScroll from 'better-scroll'
	import VFooter from '@/pages/components/v-footer'

	import {fallback,loadFromLocal,getDates,defPickerDate,defPickerAnchor} from '@/assets/js/_mm.js'
	export default {
		name: 'PlanHome',
		data () {
			return {
				picker: {
					data: this.defPickerDate(),
					textTitle: '月份选择',
					anchor: this.defPickerAnchor()
				},
				currentday: (() => {
				  return new Date().getDate() + '日'
				})(),
				currentDate: (() => {
				  return new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月'
				})(),
				currentFullYear: (() => {
					return new Date().getFullYear()
				})(),
				tips: '',
				isTips: false,
				isShow: false,
				isCreate: false,
				monthId: '',
				currentTabIndex: 1,
				total_in_count: '', //计划到诊数
				total_dialog_count: '', //计划对话数
				total_sure_count: '', // 计划确诊对话数
				total_sure_base: '', //计划确诊对话成本数
				total_in_base: '', //计划到诊成本数
				total_dialog_base: '', //计划对话成本数
				total_order_price: '', //计划消费数
				come_on: '', //计划冲刺人数
				current_in_count: '', //实际到诊数
				current_dialog_count: '', //实际对话数
				current_sure_count: '', //实际确诊对话数
				current_in_base: '', //实际到诊成本
				current_dialog_base: '', //实际对话成本
				current_sure_base: '', //实际确诊对话成本数
				current_cost_price: ''//实际消费数
			}
		},
		components: {
			VFooter
		},
		mounted ()　{
			this._initPlanScroll()
			this._initActiveScroll()
			this.getPlanInfo()
			this.getAllDate()
		},
		computed: {
			limitDate ()　{
				let date = new Date().getMonth() + 1
				let keep = this.currentDate.replace(/\d+\D+(\d+)\D+/,'$1')
				if (keep == date) {
					return '当前数据截止至' + this.currentDate + this.currentday
				} else if(keep < date) {
					return '当前数据截止至' + this.currentDate
				}else {
					return ''
				}
			}
		},
		methods: {
			fallback,
			defPickerDate,
			defPickerAnchor,
			DateSelectShow () {
				this.$refs.selectDatePicker.show()
			},
			handleSelectDate (e) {
				this.currentDate = e[0]['value'] + e[1]['value']
				this.picker.anchor = e
				this.getPlanInfo(this.currentTabIndex)
				this.getAllDate()
			},
			handleTba (number) {
				this.currentTabIndex = number
				this.getPlanInfo(this.currentTabIndex)
			},
			handleCreatePlan () {
				this.$router.push({
					name: 'InsertPlan',
					params: {
						type: 'insert',
						selectMonth: this.currentDate
					}
				})
			},
			_initPlanScroll () {
				this.$nextTick(() => {
					this.planScroll = new BScroll(this.$refs.planScroll,{
						click: true,
						swipeBounceTime: 100
					})
				})
			},
			_initActiveScroll () {
				this.$nextTick(() => {
					this.planScroll = new BScroll(this.$refs.activeScroll,{
						scrollX: true,
						click: true,
						swipeBounceTime: 100
					})
				})
			},
			recordUpdate () {
				this.$router.push({
					name: 'InsertPlan',
					params: {
						type: 'update',
						monthId: this.monthId,
						selectMonth: this.currentDate
					}
				})				
			},
			getPlanInfo (sign) {
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_month_plan_detail',
						time: this.currentDate.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2'),
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						sign: sign || 1
					}
				}).then((res) => {
					let result = res.data
					if (result.ret && result.ret === 200) {
						let data = result.data
						if(data.total_dialog_base &&　data.total_dialog_count && data.total_in_base && data.total_in_count && data.total_order_price) {
							this.isShow = true
							this.isCreate = false 
						} else {
							this.isShow = false
							this.isCreate = true
						}
						let totalOrderPrice = isNaN((data.total_order_price / 10000).toFixed(2)) ? 0 : (data.total_order_price / 10000).toFixed(2)
						let currentInBase = isNaN(Math.round(data.current_in_base)) ? 0 : Math.round(data.current_in_base)
						let currentDialogBase = isNaN(Math.round(data.current_dialog_base)) ? 0 : Math.round(data.current_dialog_base)
						let currentSureBase = isNaN(Math.round(data.current_sure_base)) ? 0 : Math.round(data.current_sure_base)
						let currentCostPrice = isNaN((data.current_cost_price / 10000).toFixed(2)) ? 0 : (data.current_cost_price / 10000).toFixed(2)

						this.monthId = data.id
						this.total_in_count = data.total_in_count //计划到诊数
						this.total_dialog_count = data.total_dialog_count //计划对话数
						this.total_sure_count = data.total_sure_count // 计划确诊对话数
						this.total_sure_base = data.total_sure_base // 计划确诊对话成本数
						this.total_in_base = data.total_in_base //计划到诊成本数
						this.total_dialog_base = data.total_dialog_base //计划对话成本数
						this.total_order_price =  totalOrderPrice//计划消费数
						this.come_on = data.come_on //计划冲刺人数
						this.current_in_count = data.current_in_count ? data.current_in_count : 0//实际到诊数
						this.current_dialog_count = data.current_dialog_count ? data.current_dialog_count : 0//实际对话数
						this.current_sure_count = data.current_sure_count // 实际确诊对话
						this.current_sure_base = currentSureBase // 实际确诊对话成本
						this.current_in_base = currentInBase//实际到诊成本
						this.current_dialog_base = currentDialogBase//实际对话成本
						this.current_cost_price = currentCostPrice//实际消费数
					}
				})
			},
			getAllDate () {
				let year = this.currentDate.replace(/(\d+)[\D]+\d+[\D]+/,'$1')
				let month = this.currentDate.replace(/\d+[\D]+(\d+)[\D]+/,'$1')
				let nowYear = new Date().getFullYear()
				let nowMonth = new Date().getUTCMonth() + 1
				let nowDate = new Date().getDate()
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_day_report',
		            	hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
		            	sign: 1,
		            	time: this.currentDate.replace(/(\d+)[\D]+(\d+)[\D]+/,'$1-$2')
					}
				}).then((res) => {
				  	let result = res.data
          			if (result.ret && result.ret === 200) {
					    let data = result.data
					    if(month == nowMonth &&　nowYear　== year) {
					    	if(nowDate - (data.length + 1) > 0) {
					    		this.tips = nowDate - (data.length + 1)
					    		this.isTips = true
					    	}else{
					    		this.isTips = false
					    	}
					    }else {
					    	if(getDates(month,year) - data.length != 0 && data.length != 0) {
					    		this.tips = getDates(month,year) - data.length
					    		this.isTips = true
					    	}else{
					    		this.isTips = false
					    	}
					    }
          			}
        		})
			}
		},
		watch: {
			isShow () {
				this._initPlanScroll()
			}
		}

	}
</script>

<style lang="stylus" scoped>
	.plan-wrapper
		width: 100%
		height: 100%
		background-color: #fff
		.header
			display: flex
			justify-content: space-between
			height: 1.1rem
			padding: 0 .2rem 0 .4rem			
			.header-title
				line-height: 1.1rem
				color: #666
				font-size: .32rem
				font-weight:bold
				.back
					display: inline-block
					width: .64rem
					.iconfont
						vertical-align: middle;
						font-size: .42rem
			.header-select
				.select-wrapper
					display: inline-block
					font-size: 0
					.select
						box-sizing: border-box
						display: inline-block
						vertical-align: top
						width: 2rem
						height: .58rem
						line-height: .58rem
						font-size: .28rem
						text-align: center
						border: 1px solid #666666
						border-right: none
					.icon-wrapper
						box-sizing: border-box
						display: inline-block
						vertical-align: top
						width: .48rem
						height: .58rem
						line-height: .58rem	
						text-align: center
						border: 1px solid #666666
						.select-icon
							font-size: .28rem
		.content-wrapper
			position: absolute
			left: 0
			right: 0
			top: 1.1rem
			bottom: 1.2rem
			z-index: 10
			overflow: hidden
			.content-tab
				width: (1.4rem * 8) - .16rem
				padding: .1rem .2rem .25rem .4rem
				font-size: 0
				background:#fff
				margin-bottom:5px
				white-space : nowrap 
				.tab-item
					display: inline-block
					vertical-align: middle
					width: 1.24rem
					height: .58rem
					line-height: .58rem
					color: #333
					font-size: .26rem
					text-align: center
					background-color: #ffffff
					border-radius: .32rem
					&+.tab-item
						margin-left: .16rem
					&.active
						color: #ffffff
						background-color: #3399ff				
			.tab-detail
				display: flex
				flex-wrap: wrap
				justify-content: space-between
				margin-top: .12rem
				.detail-item
					width: 49.5%
					margin-bottom: .1rem
					padding:15px 0
					text-align: center
					background-color: #ffffff
					.item-title
						.number-icon
							color: #666
							font-size: .75rem
						.text
							margin-top: .24rem
							margin-bottom:10px
							color: #666
							font-size: .25rem
					.number-wrap
						color: #888
						font-size: .2rem
						text-align:left
						padding:5px 15px
						.number
							color:#09f
							font-size:0.33rem
							font-weight:bold
			.total-wrapper
				padding:15px
				background-color: #ffffff
				.total-item
					display: flex
					color: #666
					font-size: .28rem
					&+.total-item
						margin-top: .5rem
					.title
						width: 40%
						b
							margin:0 3px
							color:#09f
							font-weight:bold
					.content
						width: 60%;
						text-align: center
						b
							margin:0 3px
							color:#09f
							font-weight:bold
					.col
						color: #888
						b
							color:#09f
							font-weight:bold
							margin:0 5px
				.update
					display: flex
					justify-content: space-between
					padding-top:10px
					font-size:0.2rem
					margin-top:5px
					.text
						padding: .2rem 0
						color: #888
					.btn
						padding: .2rem 0
						color: #3399ff				
		.link-grounp
			position: fixed
			left: 0
			right: 0
			bottom: 0
			font-size: 0
			.link-btn
				display: inline-block
				vertical-align: top
				width: 50%
				height: 1.2rem
				line-height: 1.2rem
				color: #ffffff
				font-size: .32rem
				text-align: center
				&:first-child
					background-color: #359aff
				&:last-child
					position: relative
					background-color: #35cdcd
					.tips
						position: absolute
						right: 16%
						top: 20%
						width: 20px
						height: 20px
						line-height: 20px
						color: #ffffff
						font-size: .24rem
						text-align: center
						background-color: red
						border-radius: 50%
		.conent-box
			display: none				
		.create-btn
			width: 3rem
			height: 1.2rem
			line-height: 1.2rem
			margin: 50% auto 0
			color: #fff
			text-align: center
			background: #09f 
			border: none
			border-radius: 0.12rem
		
</style>


// WEBPACK FOOTER //
// src/pages/plan/plan.vue